import React, { useEffect, useState } from "react";
import styling from "./ProductInput.module.css";
import { useDispatch, useSelector } from "react-redux";
import { customerItems } from "../../../../../redux/actions/actions";

function ProductInput({ guestUser }) {
  let allItems = useSelector((state) => state.salesItem);

  let [itemsArray, setItemsArray] = useState([]);
  let [itemName, setItemName] = useState("");
  let [quantity, setQuantity] = useState("");
  let [measurment, setMeasurment] = useState("");
  let [price, setPrice] = useState(0);

  useEffect(() => {
    if (guestUser) {
      setItemName("rice");
    }
  }, [guestUser]);

  useEffect(() => {
    let localArr = [];
    for (let item of Object.entries(allItems)) {
      localArr.push(item);
    }
    setItemsArray(localArr);
  }, [allItems]);

  useEffect(() => {
    if (itemName) {
      setMeasurment(allItems[itemName].measurment);
      setPrice(allItems[itemName].sellingPrice);
      setQuantity(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemName]);

  useEffect(() => {
    if (itemName) {
      setPrice(allItems[itemName].sellingPrice * quantity);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quantity]);

  let dispatch = useDispatch();

  let addItem = () => {
    let item = {
      itemName,
      quantity: parseInt(quantity),
      measurment,
      price,
      sellingPrice: allItems[itemName].sellingPrice,
    };
    dispatch(customerItems([item]));
    setItemName("");
    setQuantity(0);
    setMeasurment("");
    setPrice(0);
  };
  let removeItem = () => {
    setItemName("");
    setQuantity(0);
    setMeasurment("");
    setPrice(0);
  };
  return (
    // <form className={styling.ProductInput}>
    //   <table cellSpacing="0">
    //     <thead>
    //       <tr>
    //         <th>Product</th>
    //         <th>Quantity</th>
    //         <th>Measurment</th>
    //         <th>Price</th>
    //         <th>Action</th>
    //       </tr>
    //       <tr>
    //         <td>
    //           {" "}
    //           <select
    //             value={itemName}
    //             onChange={(e) => setItemName(e.target.value)}
    //             disabled={guestUser}
    //           >
    //             <option value="" disabled defaultValue>
    //               Select Product
    //             </option>
    //             {itemsArray.map((eachItem) => (
    //               <option value={eachItem[0]} key={eachItem[0]}>
    //                 {eachItem[0]}
    //               </option>
    //             ))}
    //           </select>
    //         </td>
    //         <td>
    //           {" "}
    //           <input
    //             type="number"
    //             value={quantity}
    //             list="items"
    //             onChange={(e) => setQuantity(e.target.value)}
    //             disabled={guestUser}
    //           />
    //         </td>
    //         <td>{measurment ? measurment : "---"}</td>
    //         <td>{price ? price : "--"}</td>
    //         <td>
    //           <button
    //             onClick={(e) => {
    //               e.preventDefault();
    //               addItem();
    //             }}
    //             disabled={guestUser}
    //             className={guestUser && "guestUserGreyBG"}
    //           >
    //             ADD
    //           </button>
    //           <button
    //             onClick={(e) => {
    //               e.preventDefault();
    //               removeItem();
    //             }}
    //             disabled={guestUser}
    //             className={guestUser && "guestUserGreyBG"}
    //           >
    //             DEL
    //           </button>
    //         </td>
    //       </tr>
    //     </thead>
    //   </table>
    // </form>

    <form className={styling.ProductInput} onSubmit={(e) => e.preventDefault()}>
      <div className={styling.productCard}>
        <div className={styling.productRow}>
          {/* Product */}
          <div className={styling.field}>
            <label htmlFor="product-select">Product</label>
            <select
              id="product-select"
              value={itemName}
              onChange={(e) => setItemName(e.target.value)}
              disabled={guestUser}
              className={styling.select}
            >
              <option value="" disabled>
                Select product
              </option>
              {itemsArray.map((eachItem) => (
                <option value={eachItem[0]} key={eachItem[0]}>
                  {eachItem[0]}
                </option>
              ))}
            </select>
          </div>

          {/* Quantity */}
          <div className={styling.field}>
            <label htmlFor="quantity-input">Quantity</label>
            <input
              id="quantity-input"
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              disabled={guestUser}
              className={styling.input}
            />
          </div>

          {/* Measurement */}
          <div className={styling.fieldReadOnly}>
            <span className={styling.fieldLabel}>Measurement</span>
            <span className={styling.pillValue}>
              {measurment ? measurment : "--"}
            </span>
          </div>

          {/* Price */}
          <div className={styling.fieldReadOnly}>
            <span className={styling.fieldLabel}>Price</span>
            <span className={styling.pillValue}>{price ? price : "--"}</span>
          </div>

          {/* Actions */}
          <div className={styling.actions}>
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                addItem();
              }}
              disabled={guestUser}
              className={`${styling.button} ${styling.addButton} ${
                guestUser ? "guestUserGreyBG" : ""
              }`}
            >
              Add
            </button>
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                removeItem();
              }}
              disabled={guestUser}
              className={`${styling.button} ${styling.deleteButton} 
              `}
            >
              Del
            </button>
          </div>
        </div>

        {guestUser && (
          <p className={styling.helperText}>
            You&apos;re in demo mode. Sign in to add or remove products.
          </p>
        )}
      </div>
    </form>
  );
}

export default ProductInput;
